import getDisplayName from 'utils/getDisplayName';

export default function withRequiredLicense() {
  return (Component) => (props) => {
    // License gate disabled on this branch: this HOC is a pass-through so the 49
    // containers that compose it stop redirecting to /subscription on mount.
    // To restore, bring back the useActiveLicense() check against UNAVAILABLE /
    // PAYMENT_REQUIRED and the <Redirect to="/subscription" />.
    Component.displayName = `withRequiredLicense(${getDisplayName(Component)})`;
    return <Component {...props} />;
  };
}
